import { supabase } from '../lib/supabase';

export const eventsService = {
  async getAllEvents() {
    try {
      const { data, error } = await supabase
        .from('events')
        .select('*')
        .order('day', { ascending: true })
        .order('time', { ascending: true });

      if (error) {
        return { count: 3, data: getMockEvents() };
      }

      return { count: data?.length || 0, data: data || [] };
    } catch (error) {
      return { count: 3, data: getMockEvents() };
    }
  },

  async getEventsByCategory(category) {
    try {
      const { data, error } = await supabase
        .from('events')
        .select('*')
        .eq('category', category)
        .order('day', { ascending: true })
        .order('time', { ascending: true });

      if (error) {
        return getMockEvents().filter(event => event.category === category);
      }

      return data || [];
    } catch (error) {
      return getMockEvents().filter(event => event.category === category);
    }
  },

  async getEventsByDay(day) {
    try {
      const { data, error } = await supabase
        .from('events')
        .select('*')
        .eq('day', day)
        .order('time', { ascending: true });

      if (error) {
        return getMockEvents().filter(event => event.day === day);
      }

      return data || [];
    } catch (error) {
      return getMockEvents().filter(event => event.day === day);
    }
  },

  async searchEvents(searchTerm) {
    try {
      const { data, error } = await supabase
        .from('events')
        .select('*')
        .or(`title.ilike.%${searchTerm}%,description.ilike.%${searchTerm}%,speaker.ilike.%${searchTerm}%`)
        .order('day', { ascending: true })
        .order('time', { ascending: true });

      if (error) {
        return getMockEvents().filter(event => 
          event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.speaker.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      return data || [];
    } catch (error) {
      return getMockEvents().filter(event => 
        event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.speaker.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }
};

// Mock events for fallback
function getMockEvents() {
  return [
    {
      id: 1,
      title: 'Opening Keynote: Future of Technology',
      description: 'Join us for an inspiring keynote address about the future of technology and innovation.',
      speaker: 'Dr. Sarah Johnson',
      category: 'keynote',
      day: 'day1',
      time: '09:00 AM - 10:30 AM',
      location: 'Main Hall',
      capacity: 500,
      attendees: 450,
      tags: ['Technology', 'Innovation', 'Keynote']
    },
    {
      id: 2,
      title: 'AI and Machine Learning Workshop',
      description: 'Hands-on workshop covering the latest developments in AI and machine learning.',
      speaker: 'Prof. Michael Chen',
      category: 'solo_talk',
      day: 'day1',
      time: '11:00 AM - 12:30 PM',
      location: 'Workshop Room A',
      capacity: 50,
      attendees: 48,
      tags: ['AI', 'Machine Learning', 'Workshop']
    },
    {
      id: 3,
      title: 'Networking Lunch',
      description: 'Connect with fellow attendees and industry professionals over lunch.',
      speaker: 'All Attendees',
      category: 'engagement_event',
      day: 'day1',
      time: '12:30 PM - 02:00 PM',
      location: 'Dining Hall',
      capacity: 300,
      attendees: 280,
      tags: ['Networking', 'Lunch']
    }
  ];
} 